<template>
  <div class="one-column-view">
    <div class="article-content">
      <div class="career-banner p-0 m-0 mb-3 w-100">
        <img
          src="../../assets/career.png"
          alt="Career"
          class="w-auto m-0 h-100"
        />
      </div>
      <h1>不要错过这个绝佳机会</h1>
      <p>
        我们的使命是在互联网上创造一个更加人性化的地方，让来自世界各地的企业和营销人员聚集在一起推广产品、进行对话、建立新的联系、学习新事物并赚钱！
      </p>
      <h1>加入我们!</h1>
      <p>我们是一支极具创造力和凝聚力的IT团队，肩负着互联网共赢的伟大使命。</p>
      <p>
        创意和共识是紧密相连的，但是因为思维的距离，共识并不是那么容易达成的。如果您想抓住这样的机会，请加入我们！
      </p>
      <p>现在申请。我们一起挑战完成使命的机会。web 3 的世界，赢，赢，赢！</p>
      <p>
        如果您拥有出色的区块链 IT
        技能，以及行业经验、创造力和我们共同的目标，那么您正是我们正在寻找的人，请在下方查看并提交您的简历：
      </p>
      <div
        class="d-flex flex-column flex-md-row justify-content-start align-items-start align-items-md-center gap-3 mb-3"
      >
        <h4 class="text-dark m-0"><strong>营销文案作家</strong></h4>
        <router-link
          to="/pages/careers-writer"
          class="btn btn-gold text-white"
          >{{ $t("careers.submitResume") }}</router-link
        >
      </div>
      <div
        class="d-flex flex-column flex-md-row justify-content-start align-items-start align-items-md-center gap-3 mb-3"
      >
        <h4 class="text-dark m-0">
          <strong>数字营销专家</strong>
        </h4>
        <router-link
          to="/pages/careers-specialist"
          class="btn btn-gold text-white"
          >{{ $t("careers.submitResume") }}</router-link
        >
      </div>
      <div
        class="d-flex flex-column flex-md-row justify-content-start align-items-start align-items-md-center gap-3 mb-3"
      >
        <h4 class="text-dark m-0"><strong>区块链开发者</strong></h4>
        <router-link
          to="/pages/careers-developer"
          class="btn btn-gold text-white"
          >{{ $t("careers.submitResume") }}</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.career-banner {
  height: 336px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
</style>
